module SharedComponents.Dividers

open Fable.React
open Fable.React.Props

let divider =
  div [ Class "dropdown-divider" ]
     [ ]